export const principles = [
  {
    number: "01",
    glyph: "♜",
    title: "YOUR GAMES, MADE USEFUL",
    description: "Chessla turns your playing history into clear lessons, recurring patterns, and practical next moves.",
  },
  {
    number: "02",
    glyph: "♝",
    title: "FACTS BEFORE NARRATIVE",
    description:
      "Legal positions and verified analysis come first. Nikola explains that evidence without inventing chess truth.",
  },
  {
    number: "03",
    glyph: "♞",
    title: "PROGRESS THAT FEELS PERSONAL",
    description: "The work starts with positions you actually reached—not a generic syllabus built for somebody else.",
  },
] as const;
